module.exports = __webpack_public_path__ + "static/img/t1-3.e59f4d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/jp/t1-3.png
// module id = SEJd
// module chunks = 1